import classes from './TeltonikaCard.module.css';
import DeviceCard from "./DeviceCard"
import removeIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png'
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import Lottie from "lottie-react";
import areYouSure from '../../../../assets/animations/areYouSure.json'
import { Button } from "primereact/button";
import { unlinkSigfoxAPI } from "../../../../Api Methods/Api";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

const TeltonikaCard = ({teltonika, pinObject, apiData, siteUUID, refreshDevices, showSuccess}) => {

    const sensorType = "BLE sensor"
    const sensorID = teltonika.type.split(" ")
    const [showConfirm, setShowConfirm] = useState(false)
    const dispatch = useDispatch();
    const role = useSelector(state => state.auth.role);

    const unlink = async () => {
        const responseData = await unlinkSigfoxAPI(apiData, siteUUID, teltonika.virtualInput, dispatch)
        if (responseData) {
            setShowConfirm(false)
            refreshDevices();
            showSuccess(true)
        }
    }

    return (
        <>
            <Dialog
                header="Are you sure?"
                visible={showConfirm}
                style={{ width: "40vw", maxWidth: "480px" }}
                onHide={() => setShowConfirm(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Lottie
                            animationData={areYouSure}
                            loop={false}
                            style={{ width: 90, height: 90, margin: "0px" }}
                        />
                        <h3 style={{ color: "rgb(147, 147, 147)", fontWeight: "500", fontSize: "16px", margin: "0" }}>
                            {`Are you sure you want to unlink this sensor?`}
                        </h3>
                    </div>
                    <div className={classes.btnRow}>
                        <Button label="No, cancel" severity="secondary" onClick={() => setShowConfirm(false)} />
                        <Button label="Yes, unlink" severity="danger" onClick={() => {unlink(); setShowConfirm(false)}} />
                    </div>
                </div>
            </Dialog>

            <DeviceCard
                header={`${sensorType}`}
                meta={[<Link to={`/Dashboard/Sensors/Sensor/${sensorID[1]}`}>{sensorID[1]}</Link>]}
                rightContent={
                <>
                    <h3 style={{color:"var(--Primary-Color)"}}>{pinObject.pinName}</h3>
                    {(role === "admin" || role === "TechSupport") && <img src={removeIcon} style={{width:"25px", cursor:"pointer"}} onClick={() => setShowConfirm(true)} />}
                </>
                }
            />
        </>
        );
}

export default TeltonikaCard;
